import { Component, computed, inject, input, output } from '@angular/core';
import { ClearingAccountLogic, InvoiceDataChangeLogic } from '@mwe/services';
import { Address, DataChangeType, Product, PushPdfInfo } from '@mwe/models';
import { BasicCardComponent } from '../../cards/basic-card/basic-card.component';
import { ButtonComponent } from '../../buttons/button/button.component';

@Component({
  selector: 'mwe-push-pdf-info-on-confirmation',
  templateUrl: './push-pdf-info-on-confirmation.component.html',
  imports: [BasicCardComponent, ButtonComponent],
})
export class PushPdfInfoOnConfirmationComponent {
  private readonly logic = inject(InvoiceDataChangeLogic);
  private readonly clearingAccountLogic = inject(ClearingAccountLogic);

  readonly info = input<PushPdfInfo>(undefined);
  readonly targetMode = input<DataChangeType>(undefined);
  readonly products = input<Product[]>(undefined);
  readonly address = input<Address>(undefined);

  readonly startProcessBtnClicked = output<void>();

  readonly cardType = computed<string>(() =>
    this.targetMode() === DataChangeType.BankAccountChangeOnly ? 'mwe-switch-to-sepa-' : 'mwe-switch-to-pdf-',
  );
  readonly buttonId = computed<string>(() => this.cardType() + 'btn');
  readonly cardId = computed<string>(() => this.cardType() + 'card');

  async startProcess(): Promise<void> {
    this.startProcessBtnClicked.emit();
    this.clearingAccountLogic.clearProductDetails();

    if (this.targetMode() === DataChangeType.BankAccountChangeOnly) {
      this.logic.startBankAccountChangeWithoutAddressSelection(this.products(), this.address());
    } else if (this.targetMode() === DataChangeType.PdfInvoiceChangeOnly) {
      this.logic.startPdfInvoiceChangeWithoutAddressSelection(this.products(), this.address());
    }
  }
}
